import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  getCurrentPathWithQuery,
  saveAuthReturnTo,
  useAuth,
  useLoginRequiredModal,
} from '@repo/common';
// 계정 유형(개인/비즈니스)별 메뉴를 쓰는 앱 GNB 드로어
import MobileMenuDrawer from '../Gnb/MobileMenuDrawer';
import { isBusinessRole } from '../Gnb/jobNavigationConfig';
import iconMenu20 from '@repo/common/assets/icons/20px/icon_20px_hamburger-menu.svg';
import iconMenu32 from '@repo/common/assets/icons/32px/icon_32px_hamburger-menu.svg';
import iconLogin24 from '@repo/common/assets/icons/24px/icon_24px_login.svg';
import iconShoppingBag24 from '@repo/common/assets/icons/24px/icon_24px_shopping-bag.svg';
import logoBlackXxs from '@repo/common/assets/logos/xxs/logo-black.svg';

function MobileComingSoonPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { showLoginModal } = useLoginRequiredModal();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const activePath = location.pathname;
  const { user } = useAuth();
  const isBusiness = isBusinessRole(user?.role);

  const handleLoginClick = () => {
    const returnTo =
      `${location.pathname}${location.search}${location.hash}` ||
      getCurrentPathWithQuery();
    saveAuthReturnTo(returnTo);
    navigate('/login', { state: { returnTo } });
  };

  return (
    <div className='flex min-h-dvh w-full flex-col bg-grayscale-gray00'>
      <MobileMenuDrawer
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        activePath={activePath}
        onLoginRequired={() => showLoginModal('mobile_coming_soon_menu')}
      />

      <header className='flex w-full shrink-0 flex-col items-start overflow-hidden bg-grayscale-gray01 px-4 py-[6px]'>
        <div className='flex h-8 w-full items-center justify-between'>
          <div className='flex h-full shrink-0 items-center gap-1'>
            <button
              type='button'
              aria-label='Open mobile menu'
              className='flex size-8 shrink-0 items-center justify-center bg-transparent p-0'
              onClick={() => setIsMenuOpen(true)}
            >
              {/* GNB 와 같이 tabletH 구간은 32px, 그 아래는 20px 메뉴 아이콘 */}
              <img
                src={iconMenu20}
                alt=''
                aria-hidden='true'
                className='size-5 tabletH:hidden'
              />
              <img
                src={iconMenu32}
                alt=''
                aria-hidden='true'
                className='hidden size-[26px] tabletH:block'
              />
            </button>

            <Link
              to='/'
              aria-label='Go to Koready home'
              className='flex h-full shrink-0 items-center justify-center'
            >
              <img
                src={logoBlackXxs}
                alt='Koready'
                className='h-5 w-[75px] object-contain'
                loading='lazy'
              />
            </Link>
          </div>

          <div className='flex h-full shrink-0 items-center'>
            <button
              type='button'
              aria-label='Login'
              className='flex h-full w-9 shrink-0 items-center justify-center bg-transparent p-0'
              onClick={handleLoginClick}
            >
              <img
                src={iconLogin24}
                alt=''
                aria-hidden='true'
                className='size-6'
              />
            </button>
            {!isBusiness && (
              <button
                type='button'
                aria-label='Shopping bag'
                className='flex h-full w-9 shrink-0 items-center justify-center bg-transparent p-0'
                onClick={() => navigate('/community/kpathport/booking')}
              >
                <img
                  src={iconShoppingBag24}
                  alt=''
                  aria-hidden='true'
                  className='size-6'
                />
              </button>
            )}
          </div>
        </div>
      </header>

      <main className='flex min-h-0 flex-1 flex-col items-center justify-center overflow-hidden px-4'>
        <div className='flex w-[240px] shrink-0 flex-col items-center gap-2 pb-20 text-center [word-break:break-word]'>
          <p className='typo-b16Strong whitespace-nowrap text-text-primary'>
            Coming Soon on Mobile
          </p>
          <p className='typo-b12 text-text-secondary'>
            For now, this page can only be accessed from a desktop device.
          </p>
        </div>
      </main>
    </div>
  );
}

export default MobileComingSoonPage;
